import { atomWithStorage } from "jotai/utils";

import { Locale, combinedStrings, defaultLocale, interfaceLocale } from "../Localization";

const locales = Object.keys(combinedStrings)
const realLocale = locales.includes(interfaceLocale) ? interfaceLocale : defaultLocale;

export const localeAtom = atomWithStorage<Locale | null>("locale", realLocale);
